/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Alert } from 'sarsaparilla';

export type EmailCodeAndNewPasswordErrorType =
    'verifyFailed' | 'lockout' | 'unknown' | null;

interface EmailCodeAndNewPasswordErrorsProps {
    errorType: EmailCodeAndNewPasswordErrorType;
    className?: string;
}

export function EmailCodeAndNewPasswordErrors({
    errorType,
    className,
}: EmailCodeAndNewPasswordErrorsProps) {
    if (!errorType) {
        return null;
    }

    if (errorType === 'verifyFailed') {
        return (
            <Alert
                type="error"
                heading="Verification Failed"
                shouldFocusOnMount
                className={className}
            >
                You supplied an incorrect verification code. Please double check your
                entry and try again.
            </Alert>
        );
    }

    if (errorType === 'lockout') {
        return (
            <Alert
                type="error"
                heading="Password Reset Limit Reached"
                shouldFocusOnMount
                className={className}
            >
                Sorry, you have changed (or attempted to change) your password too many
                times. You must wait 30 minutes before you can request another password
                reset.
            </Alert>
        );
    }

    return (
        <Alert
            type="error"
            heading="Unexpected Error"
            shouldFocusOnMount
            className={className}
        >
            Something went wrong while validating the code and/or saving your new
            password. Please try again in a moment. If the problem persists, try
            refreshing the page.
        </Alert>
    );
}
